module.exports = __webpack_public_path__ + "static/sliderm_3-82c79b5fec85526917ddb9c0eba0455e.jpg";